export default {
    active_navItem: 1,
    env: {
        theme: 0
    },
    language: {
        lang_key: localStorage.getItem('language'),
    },
    top_banner: {
        page: '',
        showSearch: false,
        isHome: true,
        business: ''
    },
    homeSection: {
        news: false,
        experience: false,
        agency: false,
        particle: false,
        information: false
    },
    global: {
        searchKey: "",
    },
    blog: {
        business: 'all'
    }
}
